import '../../common_screen/contest_details/index_web.css';
import { getMatchStatus } from '../../../utilities/helper';
import { View, Text, AddCashModal } from '../../../component';
import {
  ContestShare,
  ContestDetailsWinningBreakup,
  ContestLeaderboard,
  ContestConfirmModal
} from '../../component';
import I18n from '../../../utilities/locale';
import useTheme from '../../../utilities/hooks/theme';
import DefaultContainer from '../../../container/default_container';
import ContestCardWeb from '../../component/contest_card/index_web';

const ContestDetailsWeb = ({
  teamA,
  teamB,
  verified,
  status,
  contestDetail,
  onPressShare,
  matchStatus,
  gameState,
  matchItem,
  totalTeamsCount,
  matchDelayed,
  gameType,
  onPressJoin,
  getContestUserLeaderboard,
  getContestLeaderboard,
  fantasyMatchClick,
  completed,
  contestId,
  userId,
  winningsPerPosition,
  entryFee,
  tabType,
  matchVerifiedStatus,
  bonusPercentage,
  matchId,
  getPlayerList,
  matchTeamLock,
  myTeamList,
  isGadgetLeague_,
  description,
  questionList,
  winningData,
  contestLink,
  contestTitle,
  contestShare,
  onPressShareModalDismiss,
  contestConfirmModal,
  onPressDismissContestConfirm,
  onPressJoinContest,
  balance,
  addCashVisible,
  onPressDismissCashModal
}: any) => {
  const { FantasyTheme: theme } = useTheme();

  const footerTitle = {
    color: theme.contestDetailsFooterText
  };

  return (
    <DefaultContainer isWelcomeMessage={false}>
      <div className="contest-details-wrapper">
        <View className="my-contest-list-primary-container">
          <div className="my-contest-list-header">
            <p>{`${teamA?.shortName} vs ${teamB?.shortName}`}</p>
            {''}
            <p style={{ paddingLeft: '10px' }}>{getMatchStatus(status, verified)}</p>
          </div>
          <div
            style={{
              width: '100%',
              backgroundColor: 'rgb(255,255,255,7%)',
              display: 'flex',
              justifyContent: 'center',
              marginTop: '30px'
            }}>
            <div style={{ width: '60%', padding: '30px' }}>
              <ContestCardWeb
                isContestDetails={true}
                contest={contestDetail}
                onPressCard={() => {}}
                onPressShare={() => onPressShare()}
                matchStatus={matchStatus}
                gameState={gameState}
                matchItem={matchItem}
                totalTeamsCount={totalTeamsCount}
                screenName={'CONTEST_DETAILS'}
                matchDelayed={matchDelayed}
                gameType={gameType}
                onPressJoin={onPressJoin}
              />
            </div>
          </div>
          <View className={'contest-details-tab-view-wrapper '}>
            <div className="leaderboard-winnings-breakup-wrapper">
              <div
                style={{ display: 'flex', flexDirection: 'column', width: '50%', height: '425px' }}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <p className="leaderboard-winnings-title">Leaderboard</p>
                </div>
                <ContestLeaderboard
                  getContestUserLeaderboard={getContestUserLeaderboard}
                  getContestLeaderboard={getContestLeaderboard}
                  fantasyMatchClick={fantasyMatchClick}
                  completed={completed}
                  matchStatus={matchStatus}
                  matchItem={matchItem}
                  contestId={contestId}
                  userId={userId}
                  winningsPerPosition={winningsPerPosition}
                  entryFee={entryFee}
                  tabType={tabType}
                  matchVerifiedStatus={matchVerifiedStatus}
                  bonusPercentage={bonusPercentage}
                  gameState={gameState}
                  matchId={matchId}
                  getPlayerList={getPlayerList}
                  matchTeamLock={matchTeamLock}
                  gameType={gameType}
                  myTeamListLen={myTeamList.length}
                  isGadgetLeague={isGadgetLeague_}
                  description={description}
                  questionList={questionList}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <p className="leaderboard-winnings-title">Winnings Breakup</p>
                </div>
                <ContestDetailsWinningBreakup
                  winningData={winningData}
                  isGadgetLeague={isGadgetLeague_}
                  description={description}
                />
              </div>
            </div>
            {/* </SwipeableViews>
              </div>
            </View> */}
            <Text className={'contest-details-footer-title '} style={footerTitle}>
              {I18n.t('DeductionOver10000')}
            </Text>
          </View>
        </View>
        <ContestShare
          link={contestLink}
          contestTitle={contestTitle}
          visible={contestShare}
          onPressDismiss={onPressShareModalDismiss}
        />
        <ContestConfirmModal
          visible={contestConfirmModal}
          onPressDismiss={onPressDismissContestConfirm}
          entryFee={entryFee / 100}
          selectedTeamCount={1}
          joinContest={onPressJoinContest}
          bonusPercentage={bonusPercentage}
        />
        <AddCashModal
          totalAmount={balance['totalBalance']}
          visible={addCashVisible}
          onPressDismiss={onPressDismissCashModal}
        />
      </div>
    </DefaultContainer>
  );
};
export default ContestDetailsWeb;
